import React, { useEffect, useState } from "react";
import poolBox from "../assets/poolBox.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useActiveAccount, useActiveWalletChain } from "thirdweb/react";
import { getLpPairAddress } from "../services/apiService";
import { balanceOf, getCurrencyMetadata } from "thirdweb/extensions/erc20";
import { getErc20Contract } from "../contexts/thirdWebClient";
import { readContract } from "thirdweb";
import { ethers } from "ethers";

const Pool = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const add = useActiveAccount();
    const [, setAddress] = useState("");
    const chain = useActiveWalletChain();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (add && add.address && chain) {
            setAddress(add.address);
            getLpListOfUser(add.address, chain);
        }
    }, [add, chain]); // eslint-disable-line react-hooks/exhaustive-deps

    // Refresh data when navigating back with refresh state
    useEffect(() => {
        if (location.state?.refresh && add && add.address && chain) {
            getLpListOfUser(add.address, chain);
            // Clear the state to prevent re-fetching on subsequent renders
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

    const [, setLpAddress] = useState([]);

    const getLpListOfUser = async (address, chain) => {
        setLoading(true);
        const trxData = await getLpPairAddress(address);
        //console.log(trxData,'data')
        if (trxData.status) {
            console.log("%c Line:14 🍯 trxData", "color:#4fff4B", trxData);
            setLpAddress(trxData.data);
            fetchLpDetails(trxData.data, address, chain);
        } else {
            setLoading(false);
        }
    };

    const [lpDetails, setLpDetails] = useState([]);

    const fetchLpDetails = async (trxData, address, chain) => {
        let myLp = [];
        for (const element of trxData) {
            try {
                const contract = getErc20Contract(element.pairAddress, chain);
                let currencyMetadata = await getCurrencyMetadata({ contract });
                let pairTotalSupply = await readContract({
                    contract,
                    method: "function totalSupply() view returns (uint256)",
                    params: [],
                });
                let userBalance = await balanceOf({
                    contract,
                    address: address,
                });

                const Token0contract = getErc20Contract(
                    element?.liquiditypairs?.token0Address,
                    chain,
                );

                let tokenOMetaData = await getCurrencyMetadata({
                    contract: Token0contract,
                });
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: element.pairAddress,
                });

                const Token1contract = getErc20Contract(
                    element?.liquiditypairs?.token1Address,
                    chain,
                );
                let token1MetaData = await getCurrencyMetadata({
                    contract: Token1contract,
                });
                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: element.pairAddress,
                });

                let userShare =
                    (Number(
                        ethers.formatUnits(
                            userBalance,
                            currencyMetadata?.decimals,
                        ),
                    ) *
                        100) /
                    Number(
                        ethers.formatUnits(
                            pairTotalSupply,
                            currencyMetadata?.decimals,
                        ),
                    );

                let pairData = {
                    pairAddress: element.pairAddress,
                    token0Address: element?.liquiditypairs?.token0Address,
                    token1Address: element?.liquiditypairs?.token1Address,
                    lpName:
                        tokenOMetaData?.symbol +
                        "-" +
                        token1MetaData?.symbol +
                        " LP",
                    lpTotalSupply: Number(
                        ethers.formatUnits(
                            pairTotalSupply,
                            currencyMetadata?.decimals,
                        ),
                    ),
                    lpUserBalance: Number(
                        ethers.formatUnits(
                            userBalance,
                            currencyMetadata?.decimals,
                        ),
                    ),
                    userShare: userShare,
                    token0Name: tokenOMetaData?.name,
                    token0Symbol: tokenOMetaData?.symbol,
                    token0UserBalance:
                        (userShare *
                            Number(
                                ethers.formatUnits(
                                    tokenOUserBalance,
                                    tokenOMetaData?.decimals,
                                ),
                            )) /
                        100,
                    token1Name: token1MetaData?.name,
                    token1Symbol: token1MetaData?.symbol,
                    token1UserBalance:
                        (userShare *
                            Number(
                                ethers.formatUnits(
                                    token1UserBalance,
                                    token1MetaData?.decimals,
                                ),
                            )) /
                        100,
                };
                console.log(
                    "%c Line:85 🍰 pairData",
                    "color:#6ec1c2",
                    pairData,
                );
                myLp.push(pairData);
            } catch (error) {
                console.log("%c Line:47 🍉 error for pair:", "color:#42b983", element.pairAddress, error);
                console.log("element data:", JSON.stringify(element, null, 2));
            }
        }
        console.log("%c Line:148 🍒 myLp", "color:#ea7e5c", myLp);
        setLpDetails(myLp);
        setLoading(false);
    };

    return (
        <div className="w-full max-w-[680px] flex gap-4 flex-col card-3d p-3 sm:p-6">
            <div className="flex items-center justify-between w-full">
                <h2 className="text-[22px] font-bold gradient-text">
                    Positions
                </h2>
                <button
                    onClick={() => navigate("/pool/addliquidity/0x/0x")}
                    className="btn-3d py-2.5 px-5 text-dexora-dark text-[13px] font-bold"
                >
                    + New Position
                </button>
            </div>
            {loading ? (
                <div className="inner-3d flex flex-col items-center gap-4 justify-center w-full min-h-[220px]">
                    <div className="animate-pulse text-dexora-text-muted text-[14px] font-medium">
                        Loading positions...
                    </div>
                </div>
            ) : lpDetails && lpDetails.length > 0 ? (
                lpDetails.map((ele) => (
                    <div className="pool-card-3d overflow-hidden w-full">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between px-4 sm:px-5 py-3 sm:py-4 gap-2">
                            <h3 className="text-dexora-text-primary font-bold text-[15px] sm:text-[17px]">{ele?.lpName}</h3>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => navigate(`/pool/addliquidity/${ele?.token0Address}/${ele?.token1Address}`)}
                                    className="token-pill-3d py-1.5 px-4 text-dexora-cyan text-[12px] font-bold"
                                >
                                    Add
                                </button>
                                <button
                                    onClick={() => navigate(`/remove/liquidity/${ele?.pairAddress}`)}
                                    className="token-pill-3d py-1.5 px-4 text-dexora-text-secondary text-[12px] font-bold"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-3 sm:py-4 gap-1 sm:gap-2 border-t border-dexora-dark-tertiary/30 mx-3 sm:mx-4">
                            <div className="flex flex-col items-center gap-1">
                                <p className="font-bold text-[13px] sm:text-[15px] text-dexora-text-primary text-center">
                                    {(ele?.token0UserBalance).toFixed(4)}
                                </p>
                                <p className="text-[11px] text-dexora-text-muted font-medium">{ele?.token0Symbol}</p>
                            </div>
                            <div className="flex flex-col items-center gap-1">
                                <p className="font-bold text-[13px] sm:text-[15px] text-dexora-text-primary text-center">
                                    {(ele?.token1UserBalance).toFixed(4)}
                                </p>
                                <p className="text-[11px] text-dexora-text-muted font-medium">{ele?.token1Symbol}</p>
                            </div>
                            <div className="flex flex-col items-center gap-1">
                                <p className="font-bold text-[13px] sm:text-[15px] text-dexora-cyan">
                                    {ele?.userShare.toFixed(2)}%
                                </p>
                                <p className="text-[11px] text-dexora-text-muted font-medium">Pool Share</p>
                            </div>
                        </div>
                        {/* <div className="bg-[#f7f7f7] flex items-center justify-evenly py-6 gap-3">
                            <div className="flex flex-col items-center justify-center gap-2">
                                <p className="font-semibold text-[18px] text-[#102C57]">
                                    3376.51
                                </p>
                                <p className="font-medium text-[15px] text-[#3C486B99]">
                                    USDT per ETH
                                </p>
                            </div>
                            <div className="flex flex-col items-center justify-center gap-2">
                                <p className="font-semibold text-[18px] text-[#102C57]">
                                    0.000338823
                                </p>
                                <p className="font-medium text-[15px] text-[#3C486B99]">
                                    ETH per USDT
                                </p>
                            </div>
                            <div className="flex flex-col items-center justify-center gap-2">
                                <p className="font-semibold text-[18px] text-[#102C57]">
                                    99.65%
                                </p>
                                <p className="font-medium text-[15px] text-[#3C486B99]">
                                    Share of Pool
                                </p>
                            </div>
                        </div> */}
                    </div>
                ))
            ) : (
                <div className="inner-3d flex flex-col items-center gap-4 justify-center w-full min-h-[220px]">
                    <img src={poolBox} alt="" className="opacity-40 w-[56px]" />
                    <p className="text-[13px] text-dexora-text-muted font-medium">
                        Your liquidity positions will appear here
                    </p>
                </div>
            )}

            {/* How it Works Section */}
            <div className="mt-2 pt-4 border-t border-dexora-dark-tertiary/20">
                <p className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest mb-3">How it works</p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                    {[
                        {
                            step: "1",
                            title: "List Your Token",
                            desc: "Create a new pool for any token pair — no gatekeeping or approval required"
                        },
                        {
                            step: "2",
                            title: "Add Liquidity",
                            desc: "Deposit token pairs into a pool to provide liquidity for traders"
                        },
                        {
                            step: "3",
                            title: "Withdraw Anytime",
                            desc: "Remove your liquidity at any time — full control over your assets"
                        },
                    ].map((item, i) => (
                        <div key={i} className="pool-card-3d p-4 flex flex-col gap-2">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center bg-dexora-cyan/10 text-dexora-cyan text-[12px] font-bold">
                                {item.step}
                            </div>
                            <h4 className="text-[13px] font-bold text-dexora-text-primary">{item.title}</h4>
                            <p className="text-[11px] text-dexora-text-muted leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Pool Stats */}
            <div className="grid grid-cols-2 gap-2 mt-3">
                {[
                    { label: "Protocol", value: "AMM V2" },
                    { label: "Network", value: "BSC" },
                ].map((stat, i) => (
                    <div key={i} className="inner-3d p-3 flex flex-col items-center gap-1">
                        <span className="text-[14px] font-bold text-dexora-cyan">{stat.value}</span>
                        <span className="text-[10px] text-dexora-text-muted font-medium uppercase tracking-wider">{stat.label}</span>
                    </div>
                ))}
            </div>

            {/* Pool Info */}
            <div className="mt-2 pt-4 border-t border-dexora-dark-tertiary/20">
                <p className="text-[12px] font-semibold text-dexora-text-muted uppercase tracking-widest mb-3">Pool Features</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {[
                        {
                            icon: (
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                                </svg>
                            ),
                            title: "No lock-up period",
                            desc: "Add or remove liquidity at any time — full control over your assets",
                        },
                        {
                            icon: (
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                            ),
                            title: "List any token pair",
                            desc: "Create a new pool for any token pair — no gatekeeping or approval required",
                        },
                    ].map((item, i) => (
                        <div key={i} className="pool-card-3d p-3 flex items-start gap-3">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center bg-dexora-cyan/10 text-dexora-cyan shrink-0 mt-0.5">
                                {item.icon}
                            </div>
                            <div>
                                <p className="text-[12px] font-bold text-dexora-text-primary">{item.title}</p>
                                <p className="text-[11px] text-dexora-text-muted leading-relaxed">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Pool;
